<template>
    <b-card no-body>
         <!-- Statistics Cards -->
        <div class="row match-height px-2 pt-2 mb-2">
            <div class="col-12 col-md-6 col-lg-3">
                <v-stats-box
                    icon="receipt_long"
                    :value="statistics.TotalTransactionCount"
                    text="Toplam İşlem Sayısı"
                    variant="info"
                />
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <v-stats-box
                    icon="payments"
                    variant="success"
                    :value="statistics.TotalAmountVHStr"
                    text="Toplam Tutar (KDV Hariç)"
                />
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <v-stats-box
                    icon="receipt"
                    variant="warning"
                    :value="statistics.TotalVATStr"
                    text="Toplam KDV Tutarı"
                />
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <v-stats-box
                    icon="payments"
                    variant="danger"
                    :value="statistics.TotalAmountVDStr"
                    text="Toplam Tutar (KDV Dahil)"
                />
            </div>
        </div>

        <div class="row match-height px-2 mb-2">
            <div class="col-12 col-md-6 col-lg-3">
                <v-stats-box
                    icon="local_gas_station"
                    variant="primary"
                    :value="statistics.MotorinTotalQuantityStr"
                    text="Motorin Miktarı (Lt)"
                />
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <v-stats-box
                    icon="payments"
                    variant="primary"
                    :value="statistics.MotorinTotalAmountVHStr"
                    text="Motorin Tutarı (VH)"
                />
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <v-stats-box
                    icon="payments"
                    variant="primary"
                    :value="statistics.MotorinTotalAmountVDStr"
                    text="Motorin Tutarı (VD)"
                />
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <v-stats-box
                    icon="pin"
                    variant="primary"
                    :value="statistics.MotorinTransactionCount"
                    text="Motorin İşlem Sayısı"
                />
            </div>
        </div>

        <div class="row match-height px-2 mb-2">
            <div class="col-12 col-md-6 col-lg-3">
                <v-stats-box
                    icon="water_drop"
                    variant="warning"
                    :value="statistics.AdblueTotalQuantityStr"
                    text="Adblue Miktarı (Lt)"
                />
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <v-stats-box
                    icon="payments"
                    variant="warning"
                    :value="statistics.AdblueTotalAmountVHStr"
                    text="Adblue Tutarı (VH)"
                />
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <v-stats-box
                    icon="payments"
                    variant="warning"
                    :value="statistics.AdblueTotalAmountVDStr"
                    text="Adblue Tutarı (VD)"
                />
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <v-stats-box
                    icon="pin"
                    variant="warning"
                    :value="statistics.AdblueTransactionCount"
                    text="Adblue İşlem Sayısı"
                />
            </div>
        </div>

        <!-- Filters -->
         <b-card-body>
            <div class="row">
                 <div class="col-12 col-md-2 mb-1">
                    <v-date-picker v-model="filter.StartDate" placeholder="Başlangıç Tarihi" class="w-100" />
                </div>
                 <div class="col-12 col-md-2 mb-1">
                    <v-date-picker v-model="filter.EndDate" placeholder="Bitiş Tarihi" class="w-100" />
                </div>
                 <div class="col-12 col-md-3 mb-1">
                     <v-select-list
                        v-model="filter.VehiclePlateId"
                        :options="vehiclePlates"
                        label="PlateValue"
                        :reduce="(option) => option.Id"
                        placeholder="Plaka Seçiniz"
                    />
                </div>
                <div class="col-12 col-md-3 mb-1">
                    <v-select-list
                        v-model="filter.FuelTypeId"
                        :options="fuelTypes"
                        label="VisibleName"
                        :reduce="(option) => option.Id"
                        placeholder="Yakıt Tipi Seçiniz"
                    />
                </div>
                <div class="col-12 col-md-3 mb-1">
                    <input type="text" class="form-control" v-model="filter.FuelStationFirmName" placeholder="Firma Adı Ara..." />
                </div>
                <div class="col-12 col-md-4 col-lg-2 mb-1">
                     <b-button variant="primary" @click="refreshData" class="w-100">Filtrele</b-button>
                </div>
                <div class="col-12 col-md-4 col-lg-2 mb-1">
                     <b-button variant="outline-secondary" @click="clearFilter" class="w-100">Temizle</b-button>
                </div>
            </div>
        </b-card-body>
        


        <!-- Table -->
        <v-table
            ref="table"
            :add-callback="createNew"
            :fields="fields"
            name="buying-fuel"
            :buttons="buttons"
            pagination="server"
            :items-provider="provider"
            :filter="filter"
            initial-sort-by="Date"
            :initial-sort-desc="true"
        >
            <template #additional-actions>
                <div class="d-flex justify-content-end w-100">
                    <button
                        v-b-tooltip.hover.bottom
                        title="Excel'e Aktar"
                        class="btn btn-sm btn-icon rounded-circle btn-outline-success p-25"
                        v-on:click="downloadExcel"
                        :disabled="excelLoading"
                    >
                        <feather-icon icon="ArrowDownIcon" size="12" />
                    </button>
                </div>
            </template>
        </v-table>

        <!-- Modal -->
         <b-modal id="create-or-update-buying-fuel" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop size="lg">
            <buying-fuel-modal v-model="form" :errors="errors" />
            <template #modal-footer>
                 <v-executer :loading="loading" :editing="editing" :action="createOrUpdate" :disabled="isSaveDisabled"></v-executer>
            </template>
        </b-modal>

    </b-card>
</template>

<script>
import { BCard, BCardBody, BButton, VBTooltip } from 'bootstrap-vue'
import VStatsBox from '@/components/VStatsBox.vue'
import api from "@/api/fuel-storage";
import BuyingFuelModal from './components/BuyingFuelModal.vue'
import systemDataApi from "@/api/system-data";
import Additional from "@/utilities/additional";

export default {
    components: {
        BCard, BCardBody, BButton,
        VStatsBox,
        BuyingFuelModal
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    data() {
        return {
            loading: false,
            editing: false,
            errors: {},
            statistics: {
                TotalTransactionCount: 0,
                TotalAmountVDStr: "0.00 ₺",
                TotalAmountVHStr: "0.00 ₺",
                TotalVATStr: "0.00 ₺",
                MotorinTransactionCount: 0,
                MotorinTotalQuantityStr: "0.00",
                MotorinTotalAmountVDStr: "0.00 ₺",
                MotorinTotalAmountVHStr: "0.00 ₺",
                AdblueTransactionCount: 0,
                AdblueTotalQuantityStr: "0.00",
                AdblueTotalAmountVDStr: "0.00 ₺",
                AdblueTotalAmountVHStr: "0.00 ₺"
            },
            filter: {
                StartDate: null,
                EndDate: null,
                VehiclePlateId: null,
                FuelTypeId: null,
                FuelStationFirmName: '',
                BranchId: null,
                GarageId: null
            },
            fuelTypes: [],
            excelLoading: false,
            form: {
                Id: null,
                Date: null,
                VehiclePlateId: null,
                EmployeeId: null,
                FuelTypeId: null,
                Quantity: 0,
                VDPrice: 0,
                TaxRate: 20,
                FuelStationFirmName: '',
                ProvinceId: null,
                DistrictId: null,
                Address: '',
                Description: '',
                EmployeeCurrentBranchId: null,
                VehicleInventoryGarageId: null
            },
            vehiclePlates: [],
            fields: [
                { name: "Tarih", key: "DateValue", sortKey: "Date", sortable: true },
                { name: "Plaka", key: "VehiclePlateName", sortable: true },
                { name: "Yakıt Tipi", key: "FuelTypeName", sortable: true },
                { name: "Personel", key: "EmployeeName", sortable: true },
                { name: "Firma", key: "FuelStationFirmName", sortable: true },
                { name: "Miktar", key: "QuantityStr", sortable: true, tdClass: "text-right" },
                { name: "İl", key: "ProvinceName", sortable: true },
                { name: "İlçe", key: "DistrictName", sortable: true },
                { name: "Tutar (KDV Hariç)", key: "VHPriceStr", sortable: true, tdClass: "text-right" },
                { name: "KDV Oranı", key: "TaxRateStr", sortable: true, tdClass: "text-right" },
                { name: "KDV Tutarı", key: "TaxPriceStr", sortable: true, tdClass: "text-right" },
                { name: "Tutar (KDV Dahil)", key: "VDPriceStr", sortable: true, tdClass: "text-right" },
                { name: "Şube", key: "EmployeeCurrentBranchName", sortable: true },
                { name: "Görev Yeri", key: "VehicleInventoryGarageName", sortable: false },
                { name: "Açıklama", key: "Description", sortable: false }
            ],
            buttons: [
                { text: "Düzenle", key: "edit", icon: "Edit2Icon", variant: "secondary", action: this.edit },
                { text: "Sil", key: "delete", icon: "TrashIcon", variant: "danger", action: this.delete },
            ]

        }
    },
    mounted() {
        this.loadVehiclePlates();
        this.loadFuelTypes();
        this.loadStatistics();
    },
    methods: {
        async loadVehiclePlates() {
             try {
               const response = await systemDataApi.VehiclePlate(); // Use correct API call
               if (response.data.Success) {
                   this.vehiclePlates = response.data.Data || [];
               }
            } catch (error) {
                console.error("Vehicle plates loading error", error);
            }
        },
        async loadFuelTypes() {
            try {
                const response = await systemDataApi.FuelType(true);
                if (response.data.Success) {
                    this.fuelTypes = response.data.Data || [];
                }
            } catch (error) {
                console.error("Fuel types loading error", error);
            }
        },
        async loadStatistics() {
            try {
                const response = await api.BuyingFuel.Statistics(this.filter);
                if(response.data.Success) {
                    this.statistics = response.data.Data;
                }
            } catch (error) {
                 console.error("Statistics loading error", error);
            }
        },
        refreshData() {
            this.$refs.table.refresh();
            this.loadStatistics();
        },
        clearFilter() {
            this.filter = {
                StartDate: null,
                EndDate: null,
                VehiclePlateId: null,
                FuelTypeId: null,
                FuelStationFirmName: '',
                BranchId: null,
                GarageId: null
            };
            this.refreshData();
        },
        downloadExcel() {
            this.excelLoading = true;
            const payload = {
                ...this.filter,
                PaginationRequestModel: {
                    Skip: 0,
                    Take: 0,
                    QueryParam: null,
                    IsAscending: false,
                    OrderColumnName: "Date"
                }
            };
            api.BuyingFuel.ExcelReport(payload)
                .then((res) => {
                    if (res.data.Success) {
                        if (res.data.Data) {
                            Additional.DownloadTab(res.data.Data);
                        }
                        this.$result(res);
                    } else {
                        this.$result(res);
                    }
                })
                .catch((err) => {
                    this.$result(null, err);
                })
                .finally(() => {
                    this.excelLoading = false;
                });
        },
        provider(params) {
             const requestModel = {
                PaginationRequestModel: params,
                ...this.filter
            };
            return api.BuyingFuel.Datatable(requestModel);
        },
        createNew() {
             this.editing = false;
             this.form = {
                Id: null,
                Date: new Date(),
                TaxRate: 20,
                ProvinceId: null,
                DistrictId: null
             };
             this.$showModal("create-or-update-buying-fuel");
        },
        edit(item) {
             this.editing = true;
             this.loading = true;
             api.BuyingFuel.Get(item.Id).then(res => {
                 this.loading = false;
                 if(res.data.Success) {
                     this.form = res.data.Data;
                     this.$showModal("create-or-update-buying-fuel");
                 }
             }).catch(err => {
                 this.loading = false;
                  this.$result(null, err);
             });
        },
        delete(item) {
             this.$confirm("Silmek istediğinize emin misiniz?", `Bu işlem geri alınamaz.`).then((result) => {
                if (result) {
                    api.BuyingFuel.Delete(item.Id)
                        .then((res) => {
                            if (res.data.Success) {
                                this.refreshData();
                            }
                            this.$result(res);
                        })
                        .catch((err) => {
                            this.$result(null, err);
                        });
                }
            });
        },
        createOrUpdate() {
            this.loading = true;
             api.BuyingFuel.CreateOrUpdate(this.editing, this.form)
                .then((res) => {
                    if (res.data.Success) {
                        this.refreshData();
                        this.$hideModal("create-or-update-buying-fuel");
                    }
                    this.$result(res);
                    this.loading = false;
                })
                .catch((err) => {
                    this.$result(null, err);
                     if(err.response && err.response.data && err.response.data.Errors) {
                         this.errors = err.response.data.Errors;
                     }
                    this.loading = false;
                });
        },
    },
    computed: {
        isSaveDisabled() {
            // Add disable logic
             return false; 
        }
    }
}
</script>
